import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "flex justify-between items-center py-2" }
const _hoisted_3 = { class: "text-2xl font-bold" }
const _hoisted_4 = { class: "text-right plannedBg rounded bg-yell text-gray-600 w-min px-1.5 py-0.5 text-sm" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center gap-2 border-b-2 select-none"
}
const _hoisted_6 = { class: "isolate flex flex-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text-xs text-gray-500" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "py-2 border-b" }
const _hoisted_11 = { class: "grid grid-cols-5 gap-1 text-sm mr-2" }
const _hoisted_12 = { class: "col-span-2" }
const _hoisted_13 = { class: "col-span-2 text-right" }
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = {
  key: 0,
  class: "col-span-4"
}
const _hoisted_16 = {
  key: 1,
  class: "text-right"
}
const _hoisted_17 = { class: "border-b py-4 flex flex-col gap-3" }
const _hoisted_18 = { class: "grid grid-cols-5 gap-1 text-sm mr-2" }
const _hoisted_19 = { class: "col-span-4" }
const _hoisted_20 = { class: "font-semibold text-right" }
const _hoisted_21 = { class: "col-span-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-right" }, "x", -1)
const _hoisted_23 = { class: "grid justify-items-end" }
const _hoisted_24 = { class: "font-semibold text-right flex" }
const _hoisted_25 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_26 = { class: "cursor-default" }
const _hoisted_27 = { class: "col-span-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "text-right" }, "=", -1)
const _hoisted_29 = { class: "grid justify-items-end" }
const _hoisted_30 = { class: "font-semibold text-right flex" }
const _hoisted_31 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_32 = { class: "cursor-default" }
const _hoisted_33 = {
  key: 0,
  class: "text-sm text-gray-700 font-normal py-4 border-b"
}
const _hoisted_34 = { class: "mr-2" }
const _hoisted_35 = { class: "font-semibold" }
const _hoisted_36 = { class: "grid grid-cols-5 text-sm py-0.5 text-xs pt-2" }
const _hoisted_37 = { class: "col-span-3" }
const _hoisted_38 = { class: "text-right" }
const _hoisted_39 = { class: "text-right" }
const _hoisted_40 = { class: "col-span-3" }
const _hoisted_41 = { class: "text-right" }
const _hoisted_42 = { class: "grid justify-items-end" }
const _hoisted_43 = { class: "text-right flex" }
const _hoisted_44 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_45 = { class: "cursor-default" }
const _hoisted_46 = { class: "py-5 flex flex-col gap-2" }
const _hoisted_47 = { class: "text-sm group-hover:underline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_LockClosedIcon = _resolveComponent("LockClosedIcon")!
  const _component_OaiTooltip = _resolveComponent("OaiTooltip")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!
  const _component_ProcessVideo = _resolveComponent("ProcessVideo")!
  const _component_ArrowTopRightOnSquareIcon = _resolveComponent("ArrowTopRightOnSquareIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FlagIcon = _resolveComponent("FlagIcon")!
  const _component_IssueReportModal = _resolveComponent("IssueReportModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.selectedProcess?.name || _ctx.selectedProcess
            ? _ctx.$t(`process_classes.${_ctx.selectedProcess?.encoded_label}`)
            : ""), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.processes[0] && _ctx.formatDateDisplay(_ctx.processes[0].start_time)), 1)
    ]),
    (_ctx.processes.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.processes.length > _ctx.visibleTabCount)
            ? (_openBlock(), _createBlock(_component_ChevronLeftIcon, {
                key: 0,
                class: _normalizeClass(["w-5 h-5 cursor-pointer", [_ctx.selectedProcessIndex > 0 ? '' : 'text-gray-300']]),
                onClick: _ctx.goTabLeft
              }, null, 8, ["onClick", "class"]))
            : _createCommentVNode("", true),
          _createElementVNode("nav", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processes.slice(_ctx.processTabSkip, _ctx.processTabSkip + _ctx.visibleTabCount), (process) => {
              return (_openBlock(), _createElementBlock("div", {
                key: process._id,
                class: _normalizeClass([
            _ctx.selectedProcess === process ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700',
            'group relative min-w-0 flex-1 bg-white py-2 px-3 text-center text-sm font-medium hover:bg-gray-50 focus:z-10 cursor-pointer',
          ]),
                onClick: ($event: any) => (_ctx.selectProcess(process))
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formatTime(process.start_time)) + " - " + _toDisplayString(_ctx.formatTime(process.end_time)), 1),
                _createElementVNode("span", {
                  "aria-hidden": "true",
                  class: _normalizeClass([
              _ctx.selectedProcess === process ? 'bg-yellow-400' : 'bg-transparent',
              'absolute inset-x-0 h-0.5',
            ]),
                  style: {"bottom":"-2px"}
                }, null, 2)
              ], 10, _hoisted_7))
            }), 128))
          ]),
          (_ctx.processes.length > _ctx.visibleTabCount)
            ? (_openBlock(), _createBlock(_component_ChevronRightIcon, {
                key: 1,
                class: _normalizeClass(["w-5 h-5 cursor-pointer", [_ctx.selectedProcessIndex < _ctx.processes.length - 1 ? '' : 'text-gray-300']]),
                onClick: _ctx.goTabRight
              }, null, 8, ["onClick", "class"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedProcess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(`${_ctx.$t("analytics.processes.total_duration")}:`), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(`${_ctx.formatTime(_ctx.selectedProcess.start_time)} - ${_ctx.formatTime(_ctx.selectedProcess.end_time)}`), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(`${_ctx.getFormattedDuration(_ctx.selectedProcess.start_time, _ctx.selectedProcess.end_time)}h`), 1),
              (_ctx.selectedProcess.work_intervals.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(`${_ctx.$t("analytics.planner.processes.breaks")}:`), 1))
                : _createCommentVNode("", true),
              (_ctx.selectedProcess.work_intervals.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(`${_ctx.calculateBreakDuration(_ctx.selectedProcess as ShortenedProcess)}h`), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(`${_ctx.$t("analytics.processes.net_duration")}:`), 1),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.calculateDurationSum(_ctx.selectedProcess as ShortenedProcess)), 1),
              _createElementVNode("div", _hoisted_21, _toDisplayString(`⌀ ${_ctx.$t("analytics.processes.workers")}:`), 1),
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  (_ctx.hideWorkingHours)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createVNode(_component_OaiTooltip, { position: "left" }, {
                          tooltip: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t("paywall.working_hours")), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_LockClosedIcon, { class: "h-4 w-4 inline-block ml-2" })
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    style: _normalizeStyle({
                  filter: _ctx.hideWorkingHours ? 'blur(4px)' : '',
                  'user-select': _ctx.hideWorkingHours ? 'none' : 'auto',
                })
                  }, _toDisplayString(_ctx.calculateWorkHoursSum(_ctx.selectedProcess as ShortenedProcess) > 0
                    ? `${
                        _ctx.isAvgPeopleCountRounded(_ctx.selectedProcess as ShortenedProcess) ? "~" : ""
                      } ${_ctx.calculateWeightedAvgPeopleCount(_ctx.selectedProcess as ShortenedProcess)}`
                    : "-"), 5)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, _toDisplayString(`${_ctx.$t("analytics.processes.working_hours")}:`), 1),
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  (_ctx.hideWorkingHours)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createVNode(_component_OaiTooltip, { position: "left" }, {
                          tooltip: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t("paywall.working_hours")), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_LockClosedIcon, { class: "h-4 w-4 inline-block ml-2" })
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    style: _normalizeStyle({
                  filter: _ctx.hideWorkingHours ? 'blur(4px)' : '',
                  'user-select': _ctx.hideWorkingHours ? 'none' : 'auto',
                })
                  }, _toDisplayString(_ctx.calculateWorkHoursSum(_ctx.selectedProcess as ShortenedProcess) > 0
                    ? _ctx.calculateWorkHoursSum(_ctx.selectedProcess as ShortenedProcess)
                    : "-"), 5)
                ])
              ])
            ])
          ]),
          (_ctx.selectedProcess.work_intervals.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_Disclosure, { defaultOpen: false }, {
                    default: _withCtx(({ open }) => [
                      _createVNode(_component_DisclosureButton, { class: "flex items-center justify-between w-full" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_35, _toDisplayString(`${_ctx.$t("analytics.planner.processes.intervals")} (${
                    _ctx.selectedProcess.work_intervals.length
                  })`), 1),
                          _createVNode(_component_ChevronLeftIcon, {
                            class: _normalizeClass([{ '-rotate-90': open }, "w-5 h-5 shrink-0"])
                          }, null, 8, ["class"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_DisclosurePanel, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("analytics.processes.time_range")), 1),
                            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("analytics.processes.duration")), 1),
                            _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("analytics.processes.workers")), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProcess.work_intervals, (interval) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `${interval.start_time}-${interval.end_time}`,
                              class: "grid grid-cols-5 text-sm py-0.5"
                            }, [
                              _createElementVNode("div", _hoisted_40, _toDisplayString(`${_ctx.formatTime(interval.start_time)} - ${_ctx.formatTime(interval.end_time)}`), 1),
                              _createElementVNode("div", _hoisted_41, _toDisplayString(`${_ctx.getFormattedDuration(interval.start_time, interval.end_time)}h`), 1),
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, [
                                  (_ctx.hideWorkingHours)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                        _createVNode(_component_OaiTooltip, { position: "left" }, {
                                          tooltip: _withCtx(() => [
                                            _createElementVNode("div", null, _toDisplayString(_ctx.$t("paywall.working_hours")), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_45, [
                                              _createVNode(_component_LockClosedIcon, { class: "h-4 w-4 inline-block ml-2" })
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", {
                                    style: _normalizeStyle({
                        filter: _ctx.hideWorkingHours ? 'blur(4px)' : '',
                        'user-select': _ctx.hideWorkingHours ? 'none' : 'auto',
                      })
                                  }, _toDisplayString(interval.workforce.validated_count
                          ? interval.workforce.validated_count
                          : "-"), 5)
                                ])
                              ])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_46, [
            (_ctx.open)
              ? (_openBlock(), _createBlock(_component_ProcessVideo, {
                  key: 0,
                  loading: _ctx.videoUrlLoading,
                  src: _ctx.videoUrls[_ctx.selectedProcess._id],
                  sectionMaskId: `${_ctx.selectedProcess.section_mask_mapping.id}`,
                  processName: `${_ctx.selectedProcess.section_mask_mapping.level_name} - ${_ctx.selectedProcess.section_mask_mapping.section_name}`,
                  autoPlay: true
                }, null, 8, ["loading", "src", "sectionMaskId", "processName"]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              class: "flex self-end gap-1 items-center cursor-pointer text-sm",
              to: {
            name: 'DailyTimelapse',
            params: {
              customer_name: _ctx.currentCustomerName,
              site_id: _ctx.currentSiteId,
              camera_id: _ctx.selectedProcess.camera_id,
            },
            query: {
              date: _ctx.formatDate(_ctx.selectedProcess.date),
            },
          },
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowTopRightOnSquareIcon, {
                  class: "w-4 h-4",
                  style: {"margin-top":"-2px"}
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("app_features.daily_timelapse")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          (_ctx.hasDailyReportPermission)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "flex justify-between items-center border-b py-5 cursor-pointer border-t font-semibold",
                to: {
          name: 'SingleDailyReport',
          params: {
            customer_name: _ctx.currentCustomerName,
            site_id: _ctx.currentSiteId,
            date: _ctx.formatDate(_ctx.selectedProcess.date),
          },
        },
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("report.title")) + " ", 1),
                  _createVNode(_component_ArrowTopRightOnSquareIcon, {
                    class: "w-5 h-5",
                    style: {"margin-top":"-3px"}
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "flex justify-end mt-3 gap-2 cursor-pointer items-center text-red-600 pb-3 group",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isIssueReportModalOpen = true))
          }, [
            _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t("issue_report.report_process_issue")), 1),
            _createVNode(_component_FlagIcon, { class: "w-5 h-5" })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_IssueReportModal, {
      open: _ctx.isIssueReportModalOpen,
      process: _ctx.selectedProcess,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isIssueReportModalOpen = false)),
      onProcessUpdate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('processUpdate', $event)))
    }, null, 8, ["open", "process"])
  ]))
}